import { Actions, ActionTypes, Causes } from './actions';

export interface State {
    has_error: boolean;
    cause?: Causes;
    status?: number;
    statusText?: string;
    message?: string;
    'request-id'?: string;
    url?: string;
    method?: string;
}

export const initialState: State = {
    has_error: false,
};

export function reducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypes.SetUnhandledHttpError: {
            // prioritize logged out errors over other errors if there are multiple errors
            // fired at once
            const shouldReplaceState = !state.has_error || action.payload.cause === Causes.AccessTokenExpired;
            return shouldReplaceState
                ? {
                    has_error: true,
                    status: action.payload.status,
                    statusText: action.payload.statusText,
                    message: action.payload.message,
                    'request-id': action.payload['request-id'],
                    cause: action.payload.cause,
                    url: action.payload.url,
                    method: action.payload.method,
                }
                : state;
        }

        case ActionTypes.ClearErrors: {
            return initialState;
        }

        default:
            return state;
    }
}
